import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_LIST_FETCH } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentListSchema } from '../../schemas/Normalizr';

export function* appointmentListFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_LIST_FETCH, call(appointmentAPI.all, params), appointmentListSchema);
  } catch (e) {
    yield put(error(APPOINTMENT_LIST_FETCH, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_LIST_FETCH));
  }
}

export function* watchAppointmentListFetch() {
  yield takeEvery(APPOINTMENT_LIST_FETCH, appointmentListFetch);
}

export default function* root() {
  yield all([
    fork(watchAppointmentListFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentListFetch.js